import React from 'react';
import styles from './table.module.scss';
import { utils } from "../../../utils/utils";

export default class TableRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleEditClick = this.handleEditClick.bind(this);
    }

    handleEditClick(e) {
        e.preventDefault();
        this.props.editItemFunction(this.props.item);
    }

    renderDate(value) {
        const date = new Date(value.split('.')[0] + ".000Z");
        const stringDate = utils.formatDate(date);

        return (<div>{stringDate}</div>);
    }

    renderText(value) {
        return (<div>{value}</div>);
    }

    renderInt(value) {
        return (<div>{value}</div>);
    }

    renderFloat(value) {
        value = value.toFixed(2);
        return (<div>{value}</div>);
    }

    renderCell(column) {
        const value = this.props.item[column.name];
        switch (column.dataType) {
            case "text":
            {
                return this.renderText(value);
            }
            case "int":
            {
                return this.renderInt(value);
            }
            case "datetime":
            {
                return this.renderDate(value);
            }
            case "float":
            {
                return this.renderFloat(value);
            }
            default:
                return this.renderText(value);
        }
    }

    render() {
        return (
            <tr>
                {
                    this.props.columns.map((column, index) => <td key={index}>{this.renderCell(column)}</td>)       
                }
                {
                    this.props.isEditable && <td><button className={styles.edit_button} onClick={this.handleEditClick} /></td>
                }
            </tr>
        );
    }

}